import { Formik } from "formik";
import { useNavigate } from "react-router";
import { PropsWithChildren } from "react";

import AlertDialog from "../../common/AlertDialog";
import useAddSolutionForm, {
  SolutionFormValues,
} from "../hooks/useAddSolutionForm";
import WriteableSolutionFormContainer from "../common/form-components/";
import routes from "../../../routes";
import { solutionForm } from "../formSchema";
import { writeableSolutionFormDefaults } from "./formDefaultValues";

function AddSolutionForm() {
  const navigate = useNavigate();
  const {
    formSuccess,
    formError,
    formSubmittalLoading,
    handleSubmit,
    alert,
    setAlert,
  } = useAddSolutionForm();

  return (
    <>
      <AlertDialog
        handleClose={() => {
          setAlert(null);
          if (!formError) {
            navigate(
              routes.solutions.view({ id: formSuccess?.data.solution.id }),
            );
          }
        }}
        open={!!alert}
        title={`Add project ${alert?.type}`}
        content={alert?.message || ""}
      />
      <SolutionFormikWrapper handleSubmit={handleSubmit}>
        <WriteableSolutionFormContainer
          submitLoading={formSubmittalLoading}
          handleCancel={() => navigate(-1)}
          title="Add Project"
          page="AddSolutionPage"
        />
      </SolutionFormikWrapper>
    </>
  );
}

export const SolutionFormikWrapper = ({
  children,
  handleSubmit,
  initialValues = writeableSolutionFormDefaults,
}: PropsWithChildren<{
  handleSubmit: (formData: SolutionFormValues) => void;
  initialValues?: SolutionFormValues;
}>) => (
  <Formik
    initialValues={initialValues}
    validationSchema={solutionForm}
    onSubmit={(formData) => handleSubmit(formData)}
    validateOnMount
    initialTouched={{
      "solution-name": true,
      "solution-developer": true,
      "solution-assessment-methodology": true,
      "solution-intervention-type": true,
      "solution-short-description": true,
      "country-select": true,
      "solution-is-ready-for-sale": true,
      "solution-start-date": true,
      "solution-end-date": true,
      latitude: true,
      longitude: true,
      interventions: initialValues.interventions?.map(() => ({
        action: true,
        ecosystem: true,
      })),
      "internal-details": {
        "website-url": true,
      },
      "programme-info": {
        "asset-type": true,
        "carbon-crediting-programme": true,
      },
      "risk-monitoring": {
        "is-risk-alert-enabled": true,
        "buffer-value-km": true,
        "geospatial-file": true,
      },
    }}
  >
    {children}
  </Formik>
);

export default AddSolutionForm;
